/// <amd-module name="Test/TestCaseResults/Redux/TestCaseResultsFilterHelper" />
import { effects, SagaIterator } from "redux-saga";
import * as Constants from "Test/TestCaseResults/Constants";
import { TelemetryActions } from "Test/TestCaseResults/Redux/TelemetryActions";
import * as Utils from "Test/TestCaseResults/Utils";
import * as Contracts from "TestPlanCommon/Contracts/TestPlan";
import { getCurrentFilterState } from "VSS/Redux/Modules/ContentViewObserver";
import { IFilterItemState, IFilterState } from "VSSUI/Utilities/Filter";
import { IRunDetailsItem } from "./TestCaseResultsContracts";

export function* filterResults(allResults: Contracts.TestCaseAssociatedResult[]): SagaIterator {
    let filteredResultIds: IRunDetailsItem[] | undefined = undefined;

    if (!allResults) {
        return filteredResultIds;
    }

    const currentFilterState: IFilterState = (yield effects.select(getCurrentFilterState)) as any;
    filteredResultIds = [];

    for (const result of allResults) {
        if (matchesDropdownFilter(result, currentFilterState)) {
            filteredResultIds.push({
                pointId: result.pointId,
                runId: result.runId,
                resultId: result.resultId
            } as IRunDetailsItem);
        }
    }

    const telemetryPayload = {
        resultsCount: filteredResultIds.length,
        outcomeFilterHasValue: filterItemHasValue(currentFilterState[Constants.OutcomeFilterKey]),
        configurationFilterHasValue: filterItemHasValue(currentFilterState[Constants.ConfigurationFilterKey]),
        planFilterHasValue: filterItemHasValue(currentFilterState[Constants.PlanFilterKey]),
        suiteFilterHasValue: filterItemHasValue(currentFilterState[Constants.SuiteFilterKey]),
        testerFilterHasValue: filterItemHasValue(currentFilterState[Constants.TesterFilterKey])
    };
    yield effects.put(TelemetryActions.publishTelemetry(Constants.FILTER_VALUES_CHANGED, telemetryPayload));

    return filteredResultIds;
}

function matchesDropdownFilter(testCaseResults: Contracts.TestCaseAssociatedResult, currentFilterState: IFilterState): boolean {
    let doesMatchOutcomeFilter = true,
        doesMatchTesterFilter = true,
        doesMatchConfigurationFilter = true,
        doesMatchPlanFilter = true,
        doesMatchSuiteFilter = true;

    if (testCaseResults && currentFilterState) {
        doesMatchOutcomeFilter = matchesDropdownFilterItem(
            Utils.getOutcomeString(testCaseResults.outcome),
            currentFilterState[Constants.OutcomeFilterKey]
        );
        doesMatchTesterFilter = matchesDropdownFilterItem(
            Utils.getDisplayName(testCaseResults.tester),
            currentFilterState[Constants.TesterFilterKey]
        );
        doesMatchConfigurationFilter = matchesDropdownFilterItem(
            testCaseResults.configuration.name,
            currentFilterState[Constants.ConfigurationFilterKey]
        );
        doesMatchPlanFilter = matchesDropdownFilterItem(testCaseResults.plan.name, currentFilterState[Constants.PlanFilterKey]);
        doesMatchSuiteFilter = matchesDropdownFilterItem(testCaseResults.suite.name, currentFilterState[Constants.SuiteFilterKey]);
    }

    return doesMatchOutcomeFilter && doesMatchTesterFilter && doesMatchConfigurationFilter && doesMatchPlanFilter && doesMatchSuiteFilter;
}

function matchesDropdownFilterItem(textToMatch: any, filterItemState: IFilterItemState | null) {
    if (filterItemHasValue(filterItemState)) {
        for (const filterValItem of filterItemState!.value) {
            if (filterValItem === textToMatch || filterValItem.key === textToMatch) {
                return true;
            }
        }
        return false;
    }
    return true;
}

function filterItemHasValue(filterItemState: IFilterItemState | null): boolean {
    return filterItemState && filterItemState!.value && filterItemState!.value.length > 0;
}
